import React from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import styled from 'styled-components';

import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { ReactComponent as RightArrow } from 'app/assets/img/red_right_arrow.svg';

interface HeaderProps extends ReactDatePickerCustomHeaderProps {}

const formatMonthName = (date: Date, locale: 'vi' | 'en') => {
  if (locale === 'vi') {
    return `Tháng ${date.getMonth() + 1}`;
  }
  return date.toLocaleDateString(locale, { month: 'long' });
};

const Header = (props: HeaderProps) => {
  const { date, decreaseMonth, increaseMonth, prevMonthButtonDisabled } = props;

  const { locale } = useGlobalFunction();

  return (
    <Container>
      <ButtonControl
        onClick={decreaseMonth}
        isPrevBtn
        disabled={prevMonthButtonDisabled}
      >
        <RightArrow />
      </ButtonControl>
      <StyledMonth>{`${formatMonthName(
        date,
        locale,
      )} - ${date.getFullYear()}`}</StyledMonth>
      <ButtonControl onClick={increaseMonth}>
        <RightArrow />
      </ButtonControl>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 540px) {
    padding: 0 31px;
  }
`;

const StyledMonth = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  font-family: 'Be Vietnam Pro', sans-serif;
`;

const ButtonControl = styled.button<{ isPrevBtn?: boolean }>`
  background: none;
  outline: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: solid 1px #e92227;
  transform: ${props => (props.isPrevBtn ? 'rotate(180deg)' : 'rotate(0deg)')};
  &[disabled] {
    cursor: auto;
    border-color: #d9d9d9;
    svg path {
      stroke: #d9d9d9;
    }
  }
`;
